import { EntityType } from "../shared/enums/EntityType";

export const ROUTE_TO_ENTITY_MAP: Record<string, EntityType> = {
  // Sales & POS
  "/pos": EntityType.SALE,
  "/sales": EntityType.SALE,
  "/shifts": EntityType.SHIFT,
  "/receipts": EntityType.RECEIPT,
  "/invoices": EntityType.INVOICE,
  "/customer-orders": EntityType.CUSTOMER_ORDER,
  "/credit-notes": EntityType.CREDIT_NOTE,
  "/quotations": EntityType.QUOTATION,

  // Inventory
  "/items": EntityType.ITEM,
  "/categories": EntityType.CATEGORY,
  "/brands": EntityType.BRAND,
  "/stock": EntityType.STOCK_LEVEL,
  "/package-units": EntityType.PACKAGE_UNIT,
  "/quantity-units": EntityType.QUANTITY_UNIT,
  "/inventory-logs": EntityType.INVENTORY_LOG,

  // Procurement
  "/purchase-orders": EntityType.PURCHASE_ORDER,
  "/suppliers": EntityType.SUPPLIER,

  // CRM
  "/customers": EntityType.CUSTOMER,
  "/customer-users": EntityType.CUSTOMER_USER,

  // Finance
  "/accounts": EntityType.ACCOUNT,
  "/expenses": EntityType.EXPENSE,
  "/expense-categories": EntityType.EXPENSE_CATEGORY,
  "/debts": EntityType.DEBT,
  "/payments": EntityType.PAYMENT,
  "/ledger-entries": EntityType.LEDGER_ENTRY,

  // Communications
  "/announcements": EntityType.ANNOUNCEMENT,
  "/notifications": EntityType.NOTIFICATION,
  "/sms-templates": EntityType.SMS_TEMPLATE,
  "/sms-outbox": EntityType.SMS_OUTBOX,
  "/whatsapp-conversations": EntityType.WHATSAPP_CONVERSATION,

  // Administration & Setup
  "/branches": EntityType.BRANCH,
  "/users": EntityType.USER,
  "/roles": EntityType.ROLE,
  "/currencies": EntityType.CURRENCY,
  "/tax-codes": EntityType.TAX_CODE,
  "/document-charges": EntityType.COMPANY_CHARGE,
  "/payment-methods": EntityType.PAYMENT_METHOD,
  "/document-headers": EntityType.DOCUMENT_HEADER,
  "/sequences": EntityType.SEQUENCE,
  "/audit-logs": EntityType.AUDIT_LOG,
};

// Reverse the mapping: Entity -> Route
export const ENTITY_TO_ROUTE_MAP = Object.entries(ROUTE_TO_ENTITY_MAP).reduce(
  (acc: Record<string, string>, [route, entity]) => {
    acc[entity] = route;
    return acc;
  },
  {},
);
